<template>
    <div class="actions">
        <template>
            <v-layout row wrap fill-height>

                <v-flex xs12 class="menu-column hidden-xs-and-down">
                    <Header />
                </v-flex>

                <v-flex xs12 class="div-container-actions-card">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <div class="div-container-selects">
                                <div class="div-container-filters">
                                    <select-plus label="Anunciantes" noDataText="Nenhum anunciante"
                                        itemName="anunciante" :selected="rootSelectedAdvertisers"
                                        :items="advertiserList" v-model="selectedAdvertisers" itemText="reg_name"
                                        returnObject />

                                    <select-plus label="Categorias" noDataText="Nenhuma categoria" itemName="categoria"
                                        :items="categoryList" v-model="selectedCategories" itemText="name"
                                        returnObject />
                                </div>
                                <div class="div-container-filters-button">
                                    <button :disabled="loading" v-on:click="apply_filters"
                                        class="button-filter-actions">
                                        <v-icon class="material-icons-outlined" size="30"
                                            style="color: #40DA99 !important;">filter_list</v-icon>
                                        <p>Filtrar</p>
                                    </button>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-flex v-if="loading" xs12 sm12 md12 class="div-container-progress-loading" style="height: 50vh;">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-flex>

                    <template v-else>
                        <v-card class="table-container-card" elevation="0">
                            <v-data-table :headers="headers" :items="actions" hide-actions
                                class="actions-table full-width-table">
                                <template v-slot:items="props">
                                    <tr class="table-row-item">
                                        <td>
                                            <div class="table-store-info">
                                                <div class="store-logo-bg" v-if="props.item.anunciante">
                                                    <button class="btn-logo-zoom"
                                                        @click="openImageModal(props.item.anunciante[0].img_logo)">
                                                        <img :src="props.item.anunciante[0].img_logo"
                                                            class="store-logo-img">
                                                    </button>
                                                </div>
                                                <span class="store-name" v-if="props.item.anunciante">
                                                    {{
                                                        (props.item.anunciante[0].register &&
                                                            props.item.anunciante[0].register.reg_name)
                                                            ? props.item.anunciante[0].register.reg_name
                                                            : props.item.anunciante[0].name_tag
                                                    }}
                                                </span>
                                            </div>
                                        </td>

                                        <td class="text-xs-center">
                                            <button v-on:click="openImageModal(props.item.image_name)"
                                                style="cursor: pointer;">
                                                <img v-if="props.item.image" :src="props.item.image_name"
                                                    class="product-img-table">
                                            </button>
                                        </td>

                                        <td class="text-xs-left">
                                            <strong class="item-title">{{ props.item.name }}</strong>
                                        </td>

                                        <td class="text-xs-left">
                                            <p class="description-text">{{ props.item.description }}</p>
                                        </td>

                                        <td class="text-xs-center">
                                            <span style="font-size: 13px;">
                                                {{ formatDate(props.item.datetime_creation) }}
                                            </span>
                                        </td>

                                        <td class="text-xs-center">
                                            <span style="font-size: 13px;">
                                                {{ formatDate(props.item.datetime_expiration) }}
                                            </span>
                                        </td>
                                        <td class="text-xs-center">
                                            <div v-if="props.item.price" class="table-price">
                                                <small>R$</small> {{ props.item.price }}
                                            </div>
                                            <span v-else>---</span>
                                        </td>

                                        <td class="text-xs-center">
                                            <div v-if="props.item.cupom" class="cupom-cell-wrapper">
                                                <template v-if="copiedId !== props.item._id + 'cupom'">
                                                    <span class="cupom-code">{{ props.item.cupom }}</span>
                                                    <v-btn icon small
                                                        @click="handleCopy(props.item.cupom, props.item._id, 2, 'cupom')">
                                                        <v-icon small color="#40DA99">file_copy</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span v-else class="copied-text-status">Copiado!</span>
                                            </div>
                                            <span v-else>---</span>
                                        </td>

                                        <td class="text-xs-right">
                                            <div class="table-actions-btns">
                                                <template v-if="copiedId !== props.item._id + 'link'">
                                                    <v-btn depressed small color="#40DA99"
                                                        class="text-none btn-obter-link"
                                                        @click.stop.prevent="handleCopy(getAffiliateLink(props.item), props.item._id, 2, 'link')">
                                                        Obter Link
                                                    </v-btn>
                                                </template>
                                                <span v-else class="copied-text-status-btn">Copiado!</span>

                                                <a v-if="props.item.mktfile"
                                                    :href="`/api/shops/${props.item.advertiser}/actions_magauser/${props.item._id}/mktfile/${props.item.mktfile_name}`"
                                                    download>
                                                    <v-btn icon flat class="btn-cloud-download">
                                                        <v-icon color="#40DA99">cloud_download</v-icon>
                                                    </v-btn>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>

                        <div class="text-xs-center mb-4 mt-4">
                            <v-pagination color="#40DA99" v-model="page" :length="filters" circle
                                @input="load_actions"></v-pagination>
                        </div>
                    </template>
                </v-flex>
            </v-layout>

            <v-dialog v-model="dialogImage" max-width="600">
                <v-card style="position: relative; background-color: #2D2F32; margin-top: 70px;">
                    <v-btn icon absolute top right @click="dialogImage = false"
                        style="z-index: 9; top: 10px; right: 10px;">
                        <v-icon color="white">close</v-icon>
                    </v-btn>

                    <div style="padding: 20px; display: flex; justify-content: center; align-items: center;">
                        <img :src="selectedImage" style="max-width: 100%; max-height: 70vh; border-radius: 8px;">
                    </div>
                </v-card>
            </v-dialog>

        </template>
    </div>
</template>

<script>
import axios from 'axios'
import { affiliate_api } from '@/api'
import Header from '../components/Header.vue'
import SelectPlus from 'magafilio-vue/components/SelectPlus'

export default {
	components: { Header, SelectPlus },
	mixins: [affiliate_api],
	data() {
		return {
			actions: [],
			campaigns: [],
			loading: false,
			filters: 0,
			page: 1,
			advertiser: undefined,
			selectedAdvertisers: [],
			selectedCategories: [],
			categoryList: [],
			copiedId: null,
			dialogImage: false,
			selectedImage: '',
			headers: [
				{ text: 'Loja', value: 'store', sortable: false, width: '170px' },
				{ text: 'Foto', value: 'image', sortable: false, align: 'center', width: '120px' },
				{ text: 'Oferta', value: 'name', sortable: false, width: '200px' },
				{ text: 'Descrição', value: 'description', sortable: false, width: '350px' },
				// NOVOS HEADERS ADICIONADOS
				{ text: 'Cadastro', value: 'datetime_creation', sortable: false, align: 'center', width: '110px' },
				{ text: 'Validade', value: 'datetime_expiration', sortable: false, align: 'center', width: '110px' },
				// FIM NOVOS HEADERS
				{ text: 'Valor', value: 'price', sortable: false, align: 'center', width: '140px' },
				{ text: 'Cupom', value: 'cupom', sortable: false, align: 'center', width: '250px' },
				{ text: 'Ações', value: 'actions', sortable: false, align: 'right', width: '180px' },
			],
		}
	},
	computed: {
		affiliate() { return Object.keys(this.$root.affiliate).length !== 0 ? this.$root.affiliate : {} },
		advertiserList() {
			let list = this.$root.advertiserList || []
			return list.filter(item => item.active === true)
		},
		rootSelectedAdvertisers() { return (this.$root.selectedAdvertisers && Object.values(this.$root.selectedAdvertisers)) || [] },
	},
	methods: {
		// NOVA FUNÇÃO PARA FORMATAR DATA
		formatDate(dateString) {
			if (!dateString) return '---'
			const date = new Date(dateString)
			return date.toLocaleDateString('pt-BR')
		},
		// FIM NOVA FUNÇÃO

		openImageModal(imageUrl) {
			this.selectedImage = imageUrl
			this.dialogImage = true
		},

		getAffiliateLink(item) {
			if (!item || !item.links || !item.links.length) return ''

			let url = item.links[0].url
			let bestCampaign = this.affiliate_best_campaign(item)

			if (!item.affiliate || !item.affiliate.length || !bestCampaign || !bestCampaign.length) {
				return url
			}

			return this.link_assembly(
				url,
				item.affiliate[0]._id,
				bestCampaign[0]
			)
		},

		affiliate_best_campaign(item) {
			if (!item.affiliate || !item.affiliate.length) return []

			let bestCampaign = []
			const vetor = []

			if (item.affiliate[0].campaigns_status) {
				vetor.push(item.affiliate[0].campaigns_status)

				vetor.forEach((campanha_status) => {
					campanha_status.forEach((c_item) => {
						if (c_item.status == 'active') {
							bestCampaign.push(c_item.campaign)
						}
					})
				})
			}

			return bestCampaign
		},

		link_assembly(link, aff_id, cmp_id) {
			let parmSep = '?'

			if (link.includes('?')) {
				if (link[link.length - 1] == '?') {
					parmSep = ''
				} else {
					parmSep = '&'
				}
			}

			return `${link}${parmSep}utm_source=magafilio&utm_term=${aff_id}&utm_campaign=${cmp_id}&utm_medium=cpa`
		},

		apply_filters: async function () {
			this.page = 1 // Resetar página ao filtrar
			await this.load_actions()
		},
		async handleCopy(text, actionId, rating, type) {
			try {
				await navigator.clipboard.writeText(text)
				if (actionId) await this.handleSubmitRatingForAffiliate(localStorage.getItem('magauser'), actionId, rating)

				this.copiedId = actionId + type
				setTimeout(() => { this.copiedId = null }, 2000)
			} catch (err) {
				// console.error(err)
			}
		},
		async handleSubmitOpenLink(action_id) {
			if (action_id) {
				await this.handleSubmitRatingForAffiliate(localStorage.getItem('magauser'), action_id, 1)
			}
		},
		handleSubmitRatingForAffiliate: async function (user_id, action_id, rating) {
			await this.collect_datas_affiliate({ user_id, action_id, rating })
		},
		load_categories: async function () {
			try {
				const response = await this.get_categories_list({})
				this.categoryList = response.data
			} catch (err) {
				// console.error(err)
			}
		},
		load_actions: async function () {
			this.actions = []
			let magauser = localStorage.getItem('magauser')
			if (magauser) {
				this.loading = true
				try {
					const params = new URLSearchParams()
					params.append('page', this.page)

					this.selectedAdvertisers.forEach(adv => params.append('advs', adv._id))
					this.selectedCategories.forEach(cat => params.append('cats', cat._id || cat.name || cat))

					let response = await axios.get(`/api/affiliates/${magauser}/actions_all/`, {
						auth: { username: localStorage.getItem('mgf_login'), password: localStorage.getItem('mgf_password') },
						params: params
					})

					// Cálculo correto de páginas baseado no total retornado pelo backend
					if (response.data.total && response.data.limit) {
						this.filters = Math.ceil(response.data.total / response.data.limit)
					} else {
						this.filters = 0
					}

					this.actions = response.data.entries
				} catch (err) {
					// console.error(err)
				}
				this.loading = false
			}
		},
		load_affiliate: async function () {
			let magauser = localStorage.getItem('magauser')
			if (magauser) {
				const { data } = await this.get_mgu_aff(magauser)
				Object.assign(this.$root.affiliate, data)
			}
		},
	},
	created: async function () {
		if (this.$root.selectedAdvertisers) this.selectedAdvertisers = this.$root.selectedAdvertisers
		await this.load_categories()
		await this.load_actions()
		await this.load_affiliate()
	},
}
</script>

<style>
.actions {
    margin: 55px 10px 95px 10px;
}

.div-container-actions-card {
    padding-left: 20px;
    width: 100% !important;
    max-width: 100% !important;
}

.full-width-table {
    width: 100% !important;
}

.table-container-card {
    background: transparent !important;
    margin-top: 20px;
    width: 100%;
}

.actions-table {
    background: transparent !important;
    border-radius: 15px;
    width: 100%;
}

.table-store-info {
    display: flex;
    align-items: center;
}

.store-logo-bg {
    width: 64px;
    height: 64px;
    border-radius: 6px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.15);
}

.btn-logo-zoom {
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.store-logo-img {
    width: auto;
    height: auto;
    max-width: 85%;
    max-height: 85%;
    object-fit: contain;
}

.product-img-table {
    width: 90px;
    height: 90px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: transform 0.2s;
}

.product-img-table:hover {
    transform: scale(1.05);
}

.item-title {
    color: inherit;
    font-size: 14px;
}

.description-text {
    font-size: 11px;
    opacity: 0.7;
    margin: 0;
    line-height: 1.4;
}

.table-price {
    font-weight: bold;
    color: inherit;
    font-size: 17px;
}

.cupom-cell-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(64, 218, 153, 0.08);
    border: 1px dashed #40DA99;
    padding: 4px 8px;
    border-radius: 6px;
    min-height: 38px;
}

.table-actions-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 160px;
}

.btn-obter-link>>>.v-btn__content {
    color: #2D2F32 !important;
    font-weight: bold;
}

.copied-text-status {
    color: #40DA99;
    font-weight: bold;
    font-size: 13px;
}

.copied-text-status-btn {
    color: #40DA99;
    font-weight: bold;
    font-size: 14px;
    margin-right: 15px;
    animation: fadeIn 0.3s;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.actions .div-container-selects {
    margin-top: 25px;
    padding: 12px;
    display: flex;
    align-items: center;
    width: 100%;
}

.actions .div-container-selects .div-container-filters {
    width: 100%;
    margin-right: 25px;
    display: flex;
    align-items: center;
}

.actions .div-container-selects .div-container-filters>* {
    flex: 1;
    margin-right: 15px;
}

.actions .div-container-selects .div-container-filters>*:last-child {
    margin-right: 0px;
}

.button-filter-actions {
    border-radius: 13px;
    padding: 12px;
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #2D2F32;
    box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.button-filter-actions p {
    color: #40DA99;
    font-weight: bold;
    margin: 0;
    font-size: 14px;
}

@media (min-width: 600px) {

    .menu-column {
        flex: 0 0 215px !important;
        max-width: 215px !important;
    }

    .div-container-actions-card {
        flex: 1 !important;
        max-width: calc(100% - 215px) !important;
        width: auto !important;
    }
}
</style>